// extracted by mini-css-extract-plugin
module.exports = {"size":"color-box_size__2osX_"};